import React, { Component } from 'react'
import ActivityAndMembersCard from '../../../../components/availabilityActivityComponents/ActivityAndMembersCard'
import { Typography } from '@material-ui/core'

export default class ViewServiceCoordinators extends Component {

  onEndIconClickHandler = (id) => {
    if(id) this.props.onEndIconClickHandler(id,false)
  }


  render() {
    const { data } = this.props

    return (
      <div>
        <Typography variant="h6" style={{ padding: "14px 14px 14px 14px" }}>
          {data?.service_coordinators?.length ? data?.service_coordinators?.length : 0} Service Coordinator(s)</Typography>
        {data && data?.service_coordinators?.map((item, index) => {
          return (
            <ActivityAndMembersCard
              key={index}
              data={item}
              id={item.id}
              profilePicture={item?.profile_pic}
              title={item?.name}
              name={item?.care_provider?.name}
              onEndIconClickHandler={this.onEndIconClickHandler}
              status={item?.isactive}
            />
          )
        })}
        {/* <Typography>View all Service Coordinator Screen Needed</Typography> */}
      </div>
    )
  }
}
